import React, { useState, useEffect } from "react";
import "../styles/Forms.css";
import "../styles/Buttons.css";
import {
  convertToInputDateFormat,
  formatDateForDisplay,
} from "../utils/dateUtils";

const BatchForm = ({ initialData, products, onSubmit }) => {
  const [batchData, setBatchData] = useState({
    batch_no: initialData?.batch_no || "",
    product_code: initialData?.product_code || "",
    manufacture_date: initialData?.manufacture_date
      ? convertToInputDateFormat(initialData.manufacture_date)
      : "",
    expiry_date: initialData?.expiry_date
      ? convertToInputDateFormat(initialData.expiry_date)
      : "",
  });

  useEffect(() => {
    setBatchData({
      ...initialData,
      manufacture_date: convertToInputDateFormat(initialData.manufacture_date),
      expiry_date: convertToInputDateFormat(initialData.expiry_date),
    });
  }, [initialData]);

 
  const handleManufactureDateChange = (event) => {
    const newManufactureDateString = event.target.value; // YYYY-MM-DD
    const selectedProduct = products.find(
      (p) => p.product_code === batchData.product_code
    );
    if (!selectedProduct) {
      return;
    }

    const shelfLifeMonths = selectedProduct.shelf_life || 0;
    const manufactureDateObj = new Date(newManufactureDateString);

    manufactureDateObj.setMonth(
      manufactureDateObj.getMonth() + shelfLifeMonths
    );

    setBatchData({
      ...batchData,
      manufacture_date: newManufactureDateString,
      expiry_date: convertToInputDateFormat(manufactureDateObj),
    });
  };


  const handleProductChange = (event) => {
    const newProductCode = event.target.value;
    const selectedProduct = products.find(
      (p) => p.product_code === newProductCode
    );
    if (!selectedProduct) return;

    let newExpiryDate = batchData.expiry_date;

    if (batchData.manufacture_date) {
      const manufactureDateObj = new Date(batchData.manufacture_date);
      const shelfLifeMonths = selectedProduct.shelf_life || 0;
      manufactureDateObj.setMonth(
        manufactureDateObj.getMonth() + shelfLifeMonths
      );
      newExpiryDate = convertToInputDateFormat(manufactureDateObj);
    }

    setBatchData({
      ...batchData,
      product_code: newProductCode,
      expiry_date: newExpiryDate,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(e, batchData);
  };

  return (
    <form className="admin-form" onSubmit={handleSubmit}>
      <label>Batch No:</label>
      <input
        type="text"
        value={batchData.batch_no}
        onChange={(e) =>
          setBatchData({ ...batchData, batch_no: e.target.value })
        }
        disabled
      />

      <label>Product Code:</label>
      <select
        value={batchData.product_code}
        onChange={handleProductChange}
        required
      >
        <option value="">-- Select Product --</option>
        {products
        
          .filter(
            (product) =>
              product.is_traceable === 1 || product.is_traceable === true
          )
          .map((product) => (
            <option key={product.product_code} value={product.product_code}>
              {product.product_code} - {product.product_name}
            </option>
          ))}
      </select>

      <label>Manufacture Date:</label>
      <input
        type="date"
        value={batchData.manufacture_date}
        onChange={handleManufactureDateChange}
        required
      />

      <label>Expiry Date:</label>
      <input
        type="text"
        value={formatDateForDisplay(batchData.expiry_date)}
        disabled
      />

      <p className="info-text">
        *Batch Number cannot be changed once created. Please delete and
        re-create if needed.The expiration date is automatically calculated
        based on the production date and product shelf life.
      </p>

      <button type="submit">Save Changes</button>
    </form>
  );
};

export default BatchForm;
